// extracted by css-extract-rspack-plugin
export default {"row":"KWmIa","wrap":"X1lfn"};